import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fod_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401 handler on admin endpoints — invalidate local token and force re-login
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && url.includes("/admin/") && !url.endsWith("/admin/login")) {
      localStorage.removeItem("fod_admin_token");
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

export const LOGO_URL = "/logo.png";

export const LINKEDIN_URL = "https://www.linkedin.com/company/dmb-partners/";

export const BANKS = [
  "ARKEA",
  "BANCO SANTANDER",
  "BANQUE DELUBAC",
  "BANQUE NEUFLIZE OBC",
  "BANQUE PALATINE",
  "BANQUE POPULAIRE",
  "BNP PARIBAS",
  "CAISSE D'EPARGNE",
  "CIC",
  "CREDIT AGRICOLE",
  "CREDIT COOPERATIF",
  "CREDIT MUTUEL",
  "HSBC",
  "LA BANQUE POSTALE",
  "LCL",
  "MEMO BANK",
  "SOCIETE GENERALE",
  "THEMIS BANQUE",
  "UBS",
];

// Constants for the special "Découvert, billet de trésorerie" particularity
// U = utilisation moyenne annuelle (€)
// CPFD_base = Math.ceil(U / 500 000) * 500 000
// economieDecouvert = U * 0.0125 + CPFD_base * 0.0007
// (This particularity is EXCLUDED from the generic 0.55 multiplier.)
export const MARGE_BANQUE_DECOUVERT = 0.025;
export const CPFD_TAUX_ACTUEL = 0.001;
export const CPFD_TAUX_NEGOCIE = 0.0003;

export const PARTICULARITIES = [
  { key: "none", label: "Aucunes", rate: 0 },
  { key: "intl", label: "Virements internationaux (hors zone SEPA)", rate: 0.0015 },
  { key: "change", label: "Change (USD, GBP, YEN, etc.)", rate: 0.0005 },
  { key: "credit", label: "Crédits / remises documentaires", rate: 0.015 },
  { key: "cb", label: "Flux monétiques (CB)", rate: 0.015 },
  { key: "decouvert_billet_tresorerie", label: "Découvert, billet de trésorerie", rate: 0, special: true, inputType: "amount" },
];

export const RDV_URL = "https://cal.read.ai/fodbydmb-l0lnw";

export function formatEUR(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}
